import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { loginValidationSchema } from '../ValidationSchema/loginValidationSchema';
import axios from 'axios';
import { ConfigContext } from '../Context/ConfigContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Login = () => {
    const { apiURL, handleUpdateLogin } = useContext(ConfigContext);
    const [securityCode, setSecurityCode] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const generateRandomCode = () => {
            return Math.floor(1000 + Math.random() * 9000).toString();
        };
        setSecurityCode(generateRandomCode());
    }, []);

    const initialValues = {
        email: '',
        password: '',
        security_code: '',
        rememberMe: false,
    };

    const onSubmit = async (values, { setSubmitting, setErrors, event }) => {
        event?.preventDefault();
        if (values.security_code.toString() !== securityCode) {
            setErrors({ security_code: 'Invalid security code' });
            setSubmitting(false);
            return;
        }

        try {
            const apiEndpoint = `${apiURL}Users/UserLogin`;

            const response = await axios.post(apiEndpoint, null, {
                params: {
                    customer_email: values.email,
                    customer_password: values.password,
                    rememberMe: values.rememberMe,
                },
            });

            if (response.data.success) {
                handleUpdateLogin(response.data.data);
                toast.success('Login successful!', { position: 'bottom-center' });
                setTimeout(() => {
                    window.location.href = '/';
                }, 2000);
            } else {
                toast.error(response.data.message || 'User not found......', { position: 'top-center' });
            }
        } catch (error) {
            let errorMessage = 'An error occurred. Please try again.';
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message || 'User not found';
            }

            toast.error(errorMessage, { position: 'bottom-center' });
            setErrors({ email: errorMessage });
        } finally {
            setSubmitting(false);
        }
    };

    useEffect(() => {
        document.title = 'StoneSkill | Login'
    })

    return (
        <>
            <ToastContainer position="bottom-center" autoClose={5000} hideProgressBar={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" />
            <main className="main pages">
                <div className="page-header breadcrumb-wrap">
                    <div className="container">
                        <div className="breadcrumb">
                            <Link to="/" rel="nofollow"><i className="fi-rs-home mr-5" />Home</Link>
                            <span /> Pages <span /> My Account
                        </div>
                    </div>
                </div>
                <div className="page-content pt-150 pb-150">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-8 col-lg-10 col-md-12 m-auto">
                                <div className="row">
                                    <div className="col-lg-6 pr-30 d-none d-lg-block">
                                        <img className="border-radius-15" src="assets/imgs/page/Login-2.png" alt="Login" />
                                    </div>
                                    <div className="col-lg-6 col-md-8">
                                        <div className="login_wrap widget-taber-content background-white">
                                            <div className="padding_eight_all bg-white">
                                                <div className="heading_s1">
                                                    <h1 className="mb-5">Login</h1>
                                                    <p className="mb-30">Don't have an account? <Link to="/CreateAccount">Create here</Link></p>
                                                </div>
                                                <Formik
                                                    initialValues={initialValues}
                                                    validationSchema={loginValidationSchema}
                                                    onSubmit={onSubmit}
                                                >
                                                    {({ isSubmitting }) => (
                                                        <Form method="post">
                                                            <div className="form-group">
                                                                <Field
                                                                    type="text"
                                                                    name="email"
                                                                    placeholder="Enter Your email *"
                                                                    className="form-control"
                                                                />
                                                                <ErrorMessage
                                                                    name="email"
                                                                    component="p"
                                                                    className="text-danger"
                                                                />
                                                            </div>

                                                            <div className="form-group position-relative">
                                                                <Field
                                                                    type={showPassword ? "text" : "password"}
                                                                    name="password"
                                                                    placeholder="Your password *"
                                                                    className="form-control"
                                                                />
                                                                <span
                                                                    onClick={() => setShowPassword(!showPassword)}
                                                                    style={{ position: "absolute", top: "50%", right: "15px", transform: "translateY(-50%)", cursor: "pointer" }}
                                                                >
                                                                    <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
                                                                </span>
                                                                <ErrorMessage name="password" component="p" className="text-danger" />
                                                            </div>


                                                            <div className="login_footer form-group">
                                                                <div className="chek-form">
                                                                    <Field
                                                                        type="number"
                                                                        name="security_code"
                                                                        placeholder="Security code *"
                                                                    />
                                                                    <ErrorMessage
                                                                        name='security_code'
                                                                        component="p"
                                                                        className='text-danger'
                                                                    />
                                                                </div>
                                                                <span className="security-code">
                                                                    {securityCode.split('').map((digit, index) => (
                                                                        <b key={index} className={`text-${index % 2 === 0 ? 'new' : index % 3 === 0 ? 'sale' : 'hot'}`}>{digit}</b>
                                                                    ))}
                                                                </span>
                                                            </div>

                                                            <div className="form-group">
                                                                <button
                                                                    type="submit"
                                                                    className="btn btn-heading btn-block hover-up"
                                                                    disabled={isSubmitting}
                                                                >
                                                                    {isSubmitting ? 'Logging in...' : 'Log in'}
                                                                </button>
                                                            </div>
                                                        </Form>
                                                    )}
                                                </Formik>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default Login;